import React, { PropsWithChildren } from "react"

import { useHttp } from "@cirrus/core/http/provider"

import { useFrontendConfig } from "../../FrontendConfig"
import { CustomerInfoProvider } from "../context"
import { CustomerInfoService } from "../types/CustomerInfoService"

export const LoginCustomerInfoProvider = ({ children }: PropsWithChildren) => {
	const { Customer } = useFrontendConfig()
	const { http } = useHttp()

	const service: CustomerInfoService = {
		// @ts-ignore
		getCustomerInfo: async () => {
			return await http.get(`/api/v1/customer/${Customer}/info`)
		}
	}

	return <CustomerInfoProvider service={service}>{children}</CustomerInfoProvider>
}
